export const tr = {
    'autobudget-label': 'Autobudget priority',
    cancel: 'İptal',
    update: 'Değiştir'
};
